
// 将通讯录按照 ABCD字母的顺序排序
const sortObjByKey = (obj) => {
    const keys = Object.keys(obj).sort();
    const newObj = {};
    for (let i = 0; i < keys.length; i++) {
        const index = keys[i];
        newObj[index] = obj[index];
    }
    return newObj;
};

// 将File文件转成base64
const fileToDataUrl = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
};

// 将base64转成File
const dataURLtoFile = (dataurl, filename = "file") => {
    const arr = dataurl.split(",");
    const match = arr[0].match(/:(.*?);/) || undefined;
    const mime = match && match[1];
    const suffix = mime && mime.split("/")[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], `${filename}.${suffix}`, {
        type: mime,
    });
};

//实现将项目的图片转化成base64
const convertImgToBase64 = (
    url,
    callback,
    outputFormat
) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.onload = function () {
        canvas.height = img.height;
        canvas.width = img.width;
        ctx && ctx.drawImage(img, 0, 0);
        const dataURL = canvas.toDataURL(outputFormat || "image/png");
        callback.call(this, dataURL);
        // canvas = null;
    };
    img.src = url;
};

//实现将网络的图片转化成base64
const getBase64ByUrl = (
    src,
    callback,
    outputFormat
) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", src, true);
    xhr.responseType = "arraybuffer";
    xhr.onload = function (e) {
        if (xhr.status === 200) {
            const uInt8Array = new Uint8Array(xhr.response);
            let i = uInt8Array.length;
            const binaryString = new Array(i);
            while (i--) {
                binaryString[i] = String.fromCharCode(uInt8Array[i]);
            }
            const data = binaryString.join("");
            const base64 = window.btoa(data);
            const dataUrl =
                "data:" + (outputFormat || "image/png") + ";base64," + base64;
            callback.call(this, dataUrl);
        }
    };

    xhr.send();
};

const getExplorer = () => {
    const explorer = window.navigator.userAgent,
        compare = function (s) {
            return explorer.indexOf(s) >= 0;
        },
        ie11 = (function () {
            return "ActiveXObject" in window;
        })();
    if (compare("MSIE") || ie11) {
        return "ie";
    } else if (compare("Firefox") && !ie11) {
        return "Firefox";
    } else if (compare("Chrome") && !ie11) {
        return "Chrome";
    } else if (compare("Opera") && !ie11) {
        return "Opera";
    } else if (compare("Safari") && !ie11) {
        return "Safari";
    }
};

const forMatID = (cardId) => {
    //加密身份证
    if (cardId) {
        return cardId.toString().slice(0, 9) + "*********";
    }
    return ''
};

const dateFormat = (fmt, date) => {
    let ret;
    const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
    };
    for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
            fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
    };
    return fmt;
}

// 深拷贝
const deepClone = (target) => {
    // 定义一个变量
    let result;
    // 如果当前需要深拷贝的是一个对象的话
    if (typeof target === "object") {
        // 如果是一个数组的话
        if (Array.isArray(target)) {
            result = []; // 将result赋值为一个数组，并且执行遍历
            for (let i in target) {
                // 递归克隆数组中的每一项
                result.push(deepClone(target[i]));
            }
            // 判断如果当前的值是null的话；直接赋值为null
        } else if (target === null) {
            result = null;
            // 判断如果当前的值是一个RegExp对象的话，直接赋值
        } else if (target.constructor === RegExp) {
            result = target;
        } else {
            // 否则是普通对象，直接for in循环，递归赋值对象的所有值
            result = {};
            for (let i in target) {
                result[i] = deepClone(target[i]);
            }
        }
        // 如果不是对象的话，就是基本数据类型，那么直接赋值
    } else {
        result = target;
    }
    // 返回最终结果
    return result;
}

export {
    fileToDataUrl,
    convertImgToBase64,
    dataURLtoFile,
    getBase64ByUrl,
    sortObjByKey,
    getExplorer,
    forMatID,
    dateFormat,
    deepClone
};



// WEBPACK FOOTER //
// ./src/assets/js/index.js